import { ApiTags } from "@nestjs/swagger";
import { AdjustmentNotesService } from "./adjustment.service";
import { Body, Controller, Post } from "@nestjs/common";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { CommonResponse } from "@gtpl/shared-models/production-management";
import {AdjusmentNoteRequest,AdjustmentNoteReq, AdjutsmentNoteCategoryReq} from '@gtpl/shared-models/finance'

@ApiTags('adjustmentNotes')
@Controller('adjustmentNotes')
export class AdjustmentNoteController {
    constructor(
        private service: AdjustmentNotesService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler) {
    }
    @Post('/getAllPrintInfo')
    async getAllPrintInfo(@Body() req:AdjusmentNoteRequest): Promise<CommonResponse> {
        try {
            return await this.service.getAllPrintInfo(req);
        }
        catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/createAdjustmentNote')
    async createAdjustmentNote(@Body() req:AdjustmentNoteReq): Promise<CommonResponse> {
        try {
            return await this.service.createAdjustmentNote(req);
        }
        catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getAdjustmentNoteInfo')
    async getAdjustmentNoteInfo(@Body() req:AdjutsmentNoteCategoryReq): Promise<CommonResponse> {
        try {
            return await this.service.getAdjustmentNoteInfo(req);
        }
        catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getNoteNumberDropDown')
    async getNoteNumberDropDown(@Body() req:AdjutsmentNoteCategoryReq): Promise<CommonResponse> {
        try {
            return await this.service.getNoteNumberDropDown(req);
        }
        catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getInvoiceNumberDropDown')
    async getInvoiceNumberDropDown(@Body() req:AdjutsmentNoteCategoryReq): Promise<CommonResponse> {
        try {
            return await this.service.getInvoiceNumberDropDown(req);
        }
        catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getVendorDropDown')
    async getVendorDropDown(@Body() req:AdjutsmentNoteCategoryReq): Promise<CommonResponse> {
        try {
            return await this.service.getVendorDropDown(req);
        }
        catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
}